// App version checking and cache invalidation
export const appVersionInterceptor = {
   response: (response) => {
      if (
         !window.location.href.includes("localhost") &&
         response?.headers &&
         response.headers["app-version"]
      ) {
         if (localStorage.getItem("app-version") !== response.headers["app-version"]) {
            localStorage.setItem("app-version", response.headers["app-version"]);
            if (caches) {
               caches.keys().then((names) => {
                  for (const name of names) {
                     caches.delete(name);
                  }
               });
            }
            console.log("Version updated");
            window.location.reload(true);
         }
      }
      return response;
   },
};
